import { render, staticRenderFns } from "./QueueBoard.vue?vue&type=template&id=7a52949d&scoped=true"
import script from "./QueueBoard.vue?vue&type=script&lang=js"
export * from "./QueueBoard.vue?vue&type=script&lang=js"
import style0 from "./QueueBoard.vue?vue&type=style&index=0&id=7a52949d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a52949d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlideYReverseTransition } from 'vuetify/lib/components/transitions';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VSlideYReverseTransition,VSpacer})
